import React from "react";
import { useState } from "react";
import { useTranslation } from "react-multi-lang";

const TicketWithdrawalHistory = ({ item }) => {
  const t = useTranslation();
  const [showDetail, setShowDetail] = useState(false);
  let statusName;
  let statusColor;
  let statusTextColor;
  switch (item.status) {
    case "COMPLETED":
      statusName = t("general.completed");
      statusColor = "bg-[#A7FFA1]";
      statusTextColor = "text-[#047100]";
      break;
    case "CANCELED":
      statusName = t("general.cancelled");
      statusColor = "bg-[#FF9191]";
      statusTextColor = "text-white";
      break;
    case "PENDING":
      statusName = t("general.pending");
      statusColor = "bg-[#FCB769]";
      statusTextColor = "text-white";
      break;
    default:
      statusName = "";
      statusColor = "";
      statusTextColor = "";
      break;
  }
  return (
    <div className="bg-white rounded-xl m-2">
      <div className="sm:text-sm flex flex-row p-5">
        <div className="flex-1">{item.titleTicket}</div>
        <div>
          <span
            className={`px-2 py-1 ${statusColor} ${statusTextColor} rounded-md`}
          >
            {statusName}
          </span>
        </div>
      </div>
      <hr />
      {/* header */}
      <div
        onClick={() => setShowDetail(!showDetail)}
        className="p-5 flex items-center justify-between cursor-pointer hover:bg-gray-50 rounded-b-md"
      >
        <div className="text-md font-bold">
          {t("balance.total_amount_withdraw")}
        </div>
        <div className="flex items-center gap-2">
          <div className="flex-1 text-right text-md font-bold">
            Rp{item.totalAmountWithdraw}
          </div>
          <img
            src={process.env.REACT_APP_ASSETS_IMAGE + "arrow.svg"}
            alt=""
            className={showDetail ? "rotate-180" : ""}
          />
        </div>
      </div>
      <hr />
      {/* body */}
      {showDetail && (
        <div className="p-5 flex flex-col gap-3">
          <div className="flex items-center justify-between">
            <p className="font-bold">{t("balance.amount_withdraw")}</p>
            <span className="text-gray-400 font-medium">Rp{item.balance}</span>
          </div>
          <div className="flex items-center justify-between">
            <p className="font-bold">{t("balance.withdrawal_fee")}</p>
            <span className="text-gray-400 font-medium">
              -Rp{item.withdrawalFee}
            </span>
          </div>
        </div>
      )}
      {/* footer */}
      {/* <div className="flex px-5 pb-5">
        <div>{t("balance.total_amount")}</div>

      </div> */}
    </div>
  );
};

export default TicketWithdrawalHistory;
